var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
import { getReportFileTransportConfig } from "../../utils/reportFileDownload";
const GENERATE_EXPORT = 'api/export';
const GET_SET_REPORTS = 'api/reports';
const ATTENDANCE_API = 'api/attendance';
export const exportCustomersList = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr(['searchTerm', 'name', 'phone', 'email', 'fromDate', 'toDate', 'limit', 'pageNum', 'createdIn'], params);
            return yield this.axiosInstance.get(`${GENERATE_EXPORT}/export-all-customers?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCustomersList:', error);
            throw error;
        }
    });
};
export const exportOrdersList = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'status',
                'name',
                'phone',
                'email',
                'fromDate',
                'toDate',
                'sequence',
                'pageNum',
                'limit',
                'sequenceSort',
                'cleanedDateTime',
                'readyDateTime',
                'collectedDateTime',
                'q',
                'assignedEmployee'
            ], params);
            return yield this.axiosInstance.get(`${GENERATE_EXPORT}/export-all-orders?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportOrdersList:', error);
            throw error;
        }
    });
};
export const exportProductsList = function (storeId, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.xlsx]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const query = (options === null || options === void 0 ? void 0 : options.empty) === true ? '?empty=true' : '';
            return yield this.axiosInstance.get(`api/product/${storeId}/export${query}`, config);
        }
        catch (error) {
            console.error('Error fetching exportProductsList:', error);
            throw error;
        }
    });
};
export const exportCleanedOrdersReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cleaned-orders/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportOrdersList:', error);
            throw error;
        }
    });
};
export const exportSalesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone',
                'type'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/sales/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportOrdersList:', error);
            throw error;
        }
    });
};
export const exportCustomersReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'sortBy',
                'sortOrder',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/customers/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCustomersReport:', error);
            throw error;
        }
    });
};
export const exportSuppliesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/supplies/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCustomersReport:', error);
            throw error;
        }
    });
};
export const exportDiscountCodesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/discountCodes/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCustomersReport:', error);
            throw error;
        }
    });
};
export const exportStaffReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/staff/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCustomersReport:', error);
            throw error;
        }
    });
};
export const exportProductSalesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone',
                'groupBySection'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/productSales/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportOrdersList:', error);
            throw error;
        }
    });
};
export const exportPaymentLinesReport = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, getReportFileTransportConfig(this, options)), { headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                }, params: {
                    responseType: 'blob'
                } });
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/paymentLines/export?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const exportOutsourcingReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.xlsx]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'statuses',
                'sequence',
                'partnerId',
                'dateFrom',
                'dateTo',
                'dateField',
                'sortBy',
                'sortDirection',
                'timezone'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/outsourcing/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportOutsourcingReport:', error);
            throw error;
        }
    });
};
export function exportOrdersHistoryReport(companyId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, getReportFileTransportConfig(this, options)), { headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.xlsx]'
                }, responseType: 'blob' });
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateField',
                'dateFrom',
                'dateTo',
                'statuses',
                'sequence',
                'homeServiceOnly',
                'sortDirection',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/ordersHistory/export/csv?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
}
export const exportCashierBoxMovementsReport = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, getReportFileTransportConfig(this, options)), { headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                }, params: {
                    responseType: 'blob'
                } });
            const queryParams = generateQueryParamsStr([
                'cashierBoxId',
                'fromDate',
                'toDate',
                'timezone'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cashierBoxMovements/export?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const exportCashUpReportsByDateRange = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'cashierBoxId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cashups/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportCashUpReportsByDateRange:', error);
            throw error;
        }
    });
};
export const exportUnpaidOrdersReportCSV = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, getReportFileTransportConfig(this, options)), { headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                }, params: {
                    responseType: 'blob'
                } });
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'timezone',
                'customerName'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/unpaidOrders/export/csv?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const exportAttendanceReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'employeeId'
            ], params);
            return yield this.axiosInstance.get(`${ATTENDANCE_API}/store/${storeId}/report/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportAttendanceReport:', error);
            throw error;
        }
    });
};
export const exportScheduledDeliveriesReport = function (companyId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.xlsx]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateFrom',
                'dateTo',
                'includeDelivered'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/scheduledDeliveries/export/csv?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportScheduledDeliveriesReport:', error);
            throw error;
        }
    });
};
export const exportServicesToDeliverReport = function (companyId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.xlsx]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateFrom',
                'dateTo',
                'hideReady'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/servicesToDeliver/export/csv?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportServicesToDeliverReport:', error);
            throw error;
        }
    });
};
